import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISystemSetting } from 'types/system-settings.types';
import { initialMessage, userMessage } from 'constants/ui.constants';

interface ISystemSettingsState {
	settings: ISystemSetting[];
	loading: boolean;
	error: userMessage;
	successfullyUpdated: boolean;
}

const initialState: ISystemSettingsState = {
	settings: [],
	loading: false,
	error: initialMessage,
	successfullyUpdated: false,
};

export const systemSettingsSlice = createSlice({
	name: 'systemSettings',
	initialState,
	reducers: {
		setSettings: (state, { payload }) => {
			state.settings = payload;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setSuccessfullyUpdated: (state, { payload }) => {
			state.successfullyUpdated = payload;
		},
		updateSingleSetting: (state, { payload }) => {
			const settingIndex = state.settings.findIndex(
				(setting) => setting.domain === payload.domain && setting.key === payload.key
			);
			if (settingIndex !== -1) {
				state.settings[settingIndex] = { ...state.settings[settingIndex], ...payload };
			}
		},
	},
});

export const getSettings = (state: any) => {
	return state.systemSettings.settings;
};

export const getLoading = (state: any) => {
	return state.systemSettings.loading;
};

export const getError = (state: any) => {
	return state.systemSettings.error;
};

export const getSuccessfullyUpdated = (state: any) => {
	return state.systemSettings.successfullyUpdated;
};

export const { setSettings, setLoading, setError, setSuccessfullyUpdated, updateSingleSetting } =
	systemSettingsSlice.actions;

export default systemSettingsSlice.reducer;
